import React from 'react'
import Konsys from 'modules/konsys-ui' // eslint-disable-line
import { Spin, Icon as AntIcon } from 'antd'
import styled, { withTheme, css } from 'styled-components'
import { Link } from 'react-router-dom'
import { theme } from '../../styles/_variables'

const antIcon = <AntIcon type='loading' spin />

export const KSInputWithLabel = withTheme(Konsys.InputWithLabel)
export const BT = withTheme(Konsys.Button)
const StyledBT = styled(BT)`
  &:disabled {
    background-color: #ddd !important;
    >span {
      color: #ababab !important;
    }
    >p {
      /* font-family: sarabun !important; */
      color: #ababab !important;
    }
    >i {
      color: #ababab !important;
    }
  }
  >p {
    /* font-family: sarabun !important; */
    font-weight: bold;
    font-family: sarabun;
  }
  >span {
    font-weight: bold;
  }
`

export const InputWithLabel = styled(KSInputWithLabel)`
  border: 1px solid red;
  background-color: #ddd !important;
  &:disabled {
    background-color: #ddd !important;
    >span {
      color: #ababab !important;
    }
    >span {
      >p {
        /* font-family: sarabun !important; */
        color: #ababab !important;
      }
      >i {
        color: #ababab !important;
      }
    }
  }
  >span {
    font-weight: bold;
    >p {
      /* font-family: sarabun !important; */
      font-weight: bold;
    }
  }
`

export const CheckboxAPS = styled(withTheme(Konsys.Checkbox))`
  > input[type="checkbox"]:checked + label > span::before {
    opacity: 1 !important;
  }
  
  > input[type="checkbox"]:not(:checked) + label > span::before {
    opacity: 0 !important;
  }
  
  > label {
    > span {
      border: 1px solid ${props => (props.activeColor || theme.color.paleBlue)};
      background-color: ${props => (props.activeColor || theme.color.paleBlue)};
      width: 24px;
      height: 24px;
      position: relative;
      &:before {
        content: '✓';
        font-family: 'Font Awesome 5 Pro', 'Font Awesome 5 Free', 'fontAwesome', Arial, sans-serif;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 16px;
        color: ${theme.color.primaryColor};
        font-weight: 900;
        line-height: 1;
        opacity: 0;
        transition: opacity 0.2s;
        z-index: 2;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
      }
    }
    ${props => props.disabled && css`
      > span {
        border: 1px solid ${props.disabledColor || theme.color.paleGrey};
        background-color: ${props.disabledColor || theme.color.paleGrey};

      }
    `}
  }
`

export const Button = props => <StyledBT color={theme.color.wildWillow} inverse {...props} />
export const Icon = withTheme(Konsys.Icon)
export const TextLink = withTheme(Konsys.TextLink)
export const P = withTheme(Konsys.P)
export const H1 = withTheme(Konsys.H1)
export const H2 = withTheme(Konsys.H2)
export const H3 = withTheme(Konsys.H3)
export const H4 = withTheme(Konsys.H4)
export const Label = withTheme(Konsys.Label)
export const SmallText = withTheme(Konsys.SmallText)
export const CheckboxGroup = withTheme(Konsys.CheckboxGroup)
export const Checkbox = withTheme(Konsys.Checkbox)
export const RadioGroup = withTheme(Konsys.RadioGroup)
export const Radio = withTheme(Konsys.Radio)
export const Loading = props => <Spin indicator={antIcon} {...props} style={{ display: props.center ? 'block' : 'inline-block', margin: props.center ? '16px auto' : 'auto', ...props.style }} />
export const Select = withTheme(Konsys.Select)
export const Collapse = withTheme(Konsys.Collapse)
export const LoadingIcon = withTheme(Konsys.LoadingIcon)
export const Input = withTheme(Konsys.Input)

/* ====================== CUSTOM COMPONENT =========================== */

const LinkVariable = css`
  color: ${props => (props.color || theme.color.secondaryColor)};
  font-size: ${theme.fonts.size.normal};
  &:hover {
    color: ${props => (props.color ? `${props.color}CC` : `${theme.color.secondaryColor}CC`)};
    > i {
      color: ${props => (props.color ? `${props.color}CC` : `${theme.color.secondaryColor}CC`)};
    }
  }
  &:visited {
    color: ${props => (props.color ? `${props.color}88` : `${theme.color.secondaryColor}88`)};
    > i {
      color: ${props => (props.color ? `${props.color}88` : `${theme.color.secondaryColor}88`)};
    }
  }
  > i {
    color: ${props => (props.color || theme.color.secondaryColor)};
    transition: ${theme.animate.transition};
  }
`


export const ReactRouterLink = styled(Link)`
  ${LinkVariable}
`

export const SmallTextLink = styled(withTheme(Konsys.TextLink))`
  ${LinkVariable}
  font-size: ${theme.fonts.size.small};
`

export const SmallReactRouterLink = styled(Link)`
  ${LinkVariable}
  font-size: ${theme.fonts.size.small};
`

export const Div = withTheme(Konsys.Div)

export const DynamicButtonLink = ({ condition, props, link }) => (
  condition ? <Link to={link}><StyledBT color={theme.color.wildWillow} inverse {...props} /></Link> : <StyledBT color={theme.color.wildWillow} inverse disabled={!condition} {...props} />
)

export default Button


// export const P = props => <PKonsys {...props} style={{
//   // display: 'block', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden',
// }}/>
// export const H1 = props => <H1Konsys {...props} style={{
//   // display: 'block', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden',
// }}/>
// export const H2 = props => <H2Konsys {...props} style={{
//   // display: 'block', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden',
// }}/>
// export const H3 = props => <H3Konsys {...props} style={{
//   // display: 'block', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden',
// }}/>
// export const H4 = props => <H4Konsys {...props} style={{
//   // display: 'block', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden',
// }}/>
// export const Label = props => <LabelKonsys {...props} style={{
//   // display: 'block', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden',
// }}/>
// export const SmallText = props => <SmallTextKonsys {...props} style={{
//   // display: 'block', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden',
// }}/>
// export const Loading = withTheme(Konsys.Loading)
